module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "login-form-title"
  }, [_vm._v(_vm._s(_vm.i18n.login.signin))]), _vm._v(" "), _c('Form', {
    ref: "loginData",
    attrs: {
      "model": _vm.loginData,
      "rules": _vm.loginDataRules
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('Input-Phone', {
    staticStyle: {
      "color": "#707a80"
    },
    attrs: {
      "nextTabElId": "passwd"
    },
    on: {
      "blur": function($event) {
        _vm.submitOnClick()
      }
    },
    model: {
      value: (_vm.loginData.phone),
      callback: function($$v) {
        _vm.loginData.phone = $$v
      },
      expression: "loginData.phone"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    staticClass: "input-left-icon",
    attrs: {
      "type": "password",
      "placeholder": _vm.i18n.login.password,
      "icon": "locked",
      "size": "large",
      "id": "passwd"
    },
    on: {
      "on-enter": function($event) {
        _vm.submitOnClick()
      }
    },
    model: {
      value: (_vm.loginData.password),
      callback: function($$v) {
        _vm.loginData.password = $$v
      },
      expression: "loginData.password"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    staticClass: "login-form-button",
    attrs: {
      "type": "primary",
      "size": "large",
      "long": ""
    },
    on: {
      "click": function($event) {
        _vm.submitOnClick()
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n.login.signin))]), _vm._v(" "), _c('Row', {
    staticClass: "login-form-links-group"
  }, [_c('Col', {
    staticClass: "login-form-link text-align-center2",
    attrs: {
      "span": "12"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/welcome/signup"
    }
  }, [_vm._v(_vm._s(_vm.i18n.login.signup))])], 1), _vm._v(" "), _c('Col', {
    staticClass: "login-form-link text-align-center2",
    attrs: {
      "span": "12"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("На главную")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc6764d6","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome/SignIn.vue
// module id = 367
// module chunks = 0